<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close transfer>
			<template #default>
				<div ref="restockconfig_form"></div>
<!-- 				<vxe-grid ref="uncollection_order_list" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid> -->
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [
				{
					"type": "el-divider",
					"children": [
						"【自动任务】"
					]
				},
				{
					"type": "$inputNumber",
					"field": "auto_num",
					"title": "任务明细数量",
					"value": 8,
					"hidden": false,
					"props": {
						"readonly":false,
						"precision":0
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$switchs",
					"field": "auto_enable",
					"title": "是否开启",
					"value": 1,
					"hidden": false,
					"props": {
						"readonly":false,
						"activeValue":1,
						"inactiveValue":0,
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"【手动任务】"
					]
				},
				{
					"type": "$inputNumber",
					"field": "custom_num",
					"title": "任务明细数量",
					"value": 8,
					"hidden": false,
					"props": {
						"readonly":false,
						"precision":0
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$select",
					"field": "custom_account",
					"title": "账号",
					"value": null,
					"hidden": false,
					"props": {
						"readonly":false,
						"multiple":true,
						"allowCreate":true,
						"collapseTags":false
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "100px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '补货上架配置',
				modal_width:1000,
				modal_height:600,
				modal_model:false,
				configmodule:''
				// list_autorender:false
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 450
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width:50
					},{
						field: 'bankAcc',
						title: '我方账号',
						editRender: {
							name: '$input',
							props: {

							},
							events: {
								
							}
						},
					},
					{
						field: 'accName',
						title: '我方账号名称',
						editRender: {
							name: '$input',
							props: {
					
							},
							events: {
								
							}
						},
					},
					{
						field: 'oppAccNo',
						title: '对方账号',
						editRender: {
							name: '$input',
							props: {
					
							},
							events: {
								
							}
						},
					},
					{
						field: 'oppAccName',
						title: '对方账号名称',
						editRender: {
							name: '$input',
							props: {
					
							},
							events: {
								
							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.treeConfig = false

				gridOptions.editRules = {
					c: [{
						required: true
					},{
						// validator({cellValue,row}){
						// 	return new Promise((resolve,reject)=>{
						// 		if( true ){
						// 			reject(new Error('自定义错误'))
						// 		}else{
						// 			resolve()
						// 		}
								
						// 	})
						// }
					}]
				}
			},
			init_source_data(){
				this.sourceData = (this.data && this.data.config) ? JSON.parse(JSON.stringify(this.data.config)) : null
				this.configmodule = this.data.module
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.sourceData.uncollection_order?this.sourceData.uncollection_order:[]
					})
				})
			},
			modal_init(){
				this.init_source_data()
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.restockconfig_form
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()
					// if(this.sourceData){
					// 	this.getgrid().reloadData(this.sourceData.uncollection_order?this.sourceData.uncollection_order:[])
					// }
				})
				// this.list_init()
				this.$emit('show')
			},	
			regestevent(rule){
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}				
						this.fApi.updateRule(item.field, {
							on: on
						})
					}				
				})
			},
			setFormData(){
				if(this.sourceData){
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						if(item == 'auto_enable'){
							this.fApi.setValue(item, parseInt(this.sourceData.main[item]))
						}else{
							this.fApi.setValue(item, this.sourceData.main[item])
						}
						
					})
				}
			},
			getgrid(){
				return this.$refs.uncollection_order_list
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				this.fApi.submit((formData) => {
					let submitData = JSON.parse(JSON.stringify(formData))
					this.submitDataFormater(submitData)
					let data = {}
					data.main = submitData
					this.$api.config.save({module:this.configmodule,config:data}).then(()=>{
						this.$message.success('操作成功')
						this.$emit('success')
						this.modal_cancel()
					})
					
					// this.$api.logistictrace.updatefromlist(this.row.traceID,submitData).then(()=>{
					// 	this.$emit('success')
					// 	this.modal_cancel()
					// })
					// console.log(submitData,this.configmodule)
					// this.getgrid().validate(true, (res) => {
					// 	if (!res) {
					// 		let submitData = JSON.parse(JSON.stringify(formData))
					// 		this.submitDataFormater(submitData)
					// 		let detail = this.getgrid().getTableData().visibleData
					// 		let data = {}
					// 		data.main = submitData
					// 		data.uncollection_order = this.createDetail(detail)
					// 		this.$api.config.save({module:this.configmodule,config:data}).then(()=>{
					// 			this.$message.success('操作成功')
					// 			this.$emit('success')
					// 			this.modal_cancel()
					// 		})
					// 		//console.log(data,123123)
					// 		// this.$emit('success', {
					// 		// 	data: JSON.stringify(data)
					// 		// })
					// 		// this.modal_cancel()
					// 		console.log(data)
					// 	} else {
					// 		for (let i in res) {
					// 			console.log(res[i][0].rule)
					// 			let content = res[i][0].rule.$options.content
					// 			let message = res[i][0].rule.$options.message
					// 			if(content){
					// 				this.$message.error(content)
					// 			}else if(message){
					// 				this.$message.error(message)
					// 			}else{
					// 				this.$message.error('缺少必填项：' + res[i][0].column.title)
					// 			}
								
					// 		}
					// 	}
					// })
				}, (fApi) => {
					fApi.validate((valid, errors) => {
						if (!valid) {
							let arr = []
							for(let i in errors){
								errors[i].forEach((item)=>{
									arr.push(item.message)
								})
							}
							if(arr.length){
								this.message.error(arr[0])
							}
						}
					})
				})
				//this.init()
			},
			createDetail(data){
				data = JSON.parse(JSON.stringify(data))
				data.forEach((item)=>{
					delete(item['_X_ROW_CHILD'])
					delete(item['_X_ROW_KEY'])
				})
				return data
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>